import React, { FC } from 'react';
import { serverSideTranslation } from '../util/next';
// import { useTranslation } from 'next-i18next';

import Page from '../components/Layout/Page';
import TopBanner, { type BriefIntroInfo } from '../modules/TopBanner';
// import EventTime, { type EventItem } from '../components/EventTime';
import { getPageContent } from '../api/pagesApi';
import { genShareConfig } from '../components/Share/use-config-share';

interface Props {
  pageContentData: any;
}

const Brief: FC<Props> = (props) => {
  const { pageContentData } = props;
  const { pageContent = {}, shareContent = {} } = pageContentData || {};
  const { briefTitle, briefBgImg } = pageContent;

  // const { briefTitle, briefBgImg, detailTitle, detailBgImg, eventTitle, eventBgImg } = pageContent;
  const briefIntroInfo = pageContent.briefIntroInfo as BriefIntroInfo;
  // const detailInfo = pageContent.detailInfo as DetailInfo[];
  // const eventInfo = pageContent.eventInfo as EventItem[];
  // TODO: 先采用json获取方案
  // const { t } = useTranslation('brief');
  // const briefTitle = t('briefTitle');
  // const briefBgImg = t('briefBgImg');
  // const briefIntroInfo: BriefIntroInfo = t('briefIntroInfo', { returnObjects: true });

  // const detailTitle = t('detailTitle');
  // const detailBgImg = t('detailBgImg');
  // const detailInfo: DetailInfo[] = t('detailInfo', { returnObjects: true });

  // const eventTitle = t('eventTitle');
  // const eventBgImg = t('eventBgImg');
  // const eventInfo: EventItem[] = t('eventInfo', { returnObjects: true });

  return (
    <Page title={shareContent.shareTitle}>
      {/* 顶部banner */}
      <TopBanner briefTitle={briefTitle} briefIntroInfo={briefIntroInfo} briefBgImg={briefBgImg} />
      {/* 公司大事记 */}
      {/* <EventTime eventInfo={eventInfo} eventTitle={eventTitle} eventBgImg={eventBgImg} /> */}
    </Page>
  );
};
export async function getServerSideProps({ locale = 'en-US', query }: any) {
  const pageContentParams = {
    uri: '/about-us',
    pageContentNo: query.pageContentNo,
    preview: query.preview,
  };
  const pageContentData = await getPageContent(pageContentParams, locale);
  return {
    props: {
      pageContentData,
      ...genShareConfig(pageContentData),
      ...(await serverSideTranslation(locale, ['brief', 'cookie', 'common'])),
    },
  };
}

export default Brief;
